module.exports = __webpack_public_path__ + "static/ECEM_BATU-8092bbbb2ff1580ee9e7f3c190114640.jpeg";